export const ESC_KEY = "Escape";
export const TAB_KEY = "Tab";
export const ARROW_UP_KEY = "ArrowUp";
export const ARROW_DOWN_KEY = "ArrowDown";
export const ARROW_RIGHT_KEY = "ArrowRight";
export const ARROW_LEFT_KEY = "ArrowLeft";
export const SPACE_KEY = " ";
export const ENTER_KEY = "Enter";
